export default __webpack_public_path__ + "static/media/bg-proyecto.5b45e03c.jpeg";